import { all } from 'redux-saga/effects';
import messages from '@benniehealth/core-js/store/messages';
import claims from '@benniehealth/core-js/store/claims';
import marketplace from '@benniehealth/core-js/store/marketplace';
import * as admin from '@benniehealth/core-js/store/admin';
import perks from '@benniehealth/core-js/store/perks';
import postLoginExperience from '@benniehealth/core-js/store/postLoginExperience';
import profile from '@benniehealth/core-js/store/profile';
import blogPosts from '@benniehealth/core-js/store/blogPosts';
import { insights } from '@benniehealth/insights-js';
import { fetchInitialDataWatcher } from '@app/store/appState/sagas';
import {
  deleteProviderWatcher,
  fetchSavedProvidersWatcher,
  saveProviderWatcher,
} from '@app/store/findADoctor/sagas';

import {
  fetchSavedFacilitiesWatcher,
  saveFacilityWatcher,
  fetchItemWatcher,
  searchWatcher,
  deleteFacilityWatcher,
  deleteProviderWatcher as deleteProviderWatcherMC,
  saveProviderWatcher as saveProviderWatcherMC,
  fetchSavedProvidersWatcher as fetchSavedProvidersWatcherMC,
} from '@app/store/findMedicalCare/sagas';

import { saveSessionWatcher } from '@app/store/sessions/sagas';

import { checkCompanyAccessWatcher } from '@app/store/companyAccesses/sagas';

import { logoutWatcher } from '@app/store/auth/sagas';

import { checkLocationPermissionsWatcher } from '@app/store/location/sagas';

import { fetchBlogPosts } from '@app/api/contentful';

import {
  toggleAskBennieAiModalWatcher,
  toggleAskBennieModalWatcher,
} from '@app/store/modal/sagas';

import { adminRequestAvailableCompanyExportsWatcher } from '@app/store/admin/exports/sagas';
import { adminRequestUsersWatcher } from '@app/store/admin/users/sagas';
import {
  adminFetchSSOConfigWatcher,
  adminCreateSSOConfigWatcher,
  adminDeleteSSOConfigWatcher,
  adminEnableSSOConfigWatcher,
} from '@app/store/admin/sso/sagas';
import { fetchDocumentsWatcher } from '@app/store/enrollmentDocuments/sagas';
import { fetchClientAttributesWatcher } from '@app/store/clientAttributes/sagas';
import { getTelehealthConfigurationWatcher } from '@app/store/telehealth/sagas';
import * as messagesApi from '@app/api/messages';
import * as claimsApi from '@app/api/deductibleDetails';
import * as marketplaceApi from '@app/api/marketplace';
import {
  fetchAdminPerks,
  fetchAdminArchivedPerks,
  fetchAdminPerk,
} from '@app/api/admin/perks';
import { fetchPerks } from '@app/api/perks';
import {
  completeAppTutorial,
  fetchRestartAppTutorial,
} from '@app/api/postLoginExperience';
import * as profileApi from '@app/api/profile';
import * as dependentsApi from '@app/api/dependents';
import { fetchInsights } from '@app/api/insights';

export default function* rootSaga() {
  yield all([
    fetchInitialDataWatcher(),
    toggleAskBennieModalWatcher(),
    toggleAskBennieAiModalWatcher(),
    fetchClientAttributesWatcher(),
    profile.sagas.fetchProfileWatcher(profileApi.fetchProfile),
    profile.sagas.fetchApplicationStatusWatcher(
      profileApi.fetchProfileApplicationStatus,
    ),
    searchWatcher(),
    deleteProviderWatcher(),
    fetchSavedProvidersWatcher(),
    saveProviderWatcher(),
    fetchSavedFacilitiesWatcher(),
    fetchItemWatcher(),
    saveFacilityWatcher(),
    deleteFacilityWatcher(),
    deleteProviderWatcherMC(),
    saveProviderWatcherMC(),
    fetchSavedProvidersWatcherMC(),
    saveSessionWatcher(),
    checkLocationPermissionsWatcher(),
    adminRequestAvailableCompanyExportsWatcher(),
    adminRequestUsersWatcher(),
    adminFetchSSOConfigWatcher(),
    adminCreateSSOConfigWatcher(),
    adminDeleteSSOConfigWatcher(),
    adminEnableSSOConfigWatcher(),
    fetchDocumentsWatcher(),
    checkCompanyAccessWatcher(),
    getTelehealthConfigurationWatcher(),
    logoutWatcher(),
    profile.sagas.fetchDependentsWatcher(dependentsApi.getDependentsList),
    messages.sagas.fetchTicketWatcher(messagesApi.fetchTicket),
    messages.sagas.fetchTicketsWatcher(messagesApi.fetchOpenTickets),
    messages.sagas.fetchResolvedTicketsWatcher(
      messagesApi.fetchResolvedTickets,
    ),
    messages.sagas.fetchAgentsWatcher(messagesApi.fetchAgents),
    messages.sagas.fetchTicketFieldsWatcher(messagesApi.fetchTicketFields),
    messages.sagas.createTicketWatcher(messagesApi.createTicket),
    messages.sagas.updateTicketWatcher(messagesApi.updateTicket),
    messages.sagas.fetchCommentsWatcher(messagesApi.fetchComments),
    messages.sagas.fetchZendeskUserWatcher(messagesApi.fetchZendeskUser),
    messages.sagas.pollTicketUpdatesWatcher(),
    claims.sagas.fetchDeductibleDetailsWatcher(
      claimsApi.fetchDeductibleDetails,
      claimsApi.fetchDeductibleDetailsCache,
      claimsApi.updateDeductibleDetailsCache,
    ),
    marketplace.sagas.fetchEmployeeMarketplaceWatcher(
      marketplaceApi.fetchEmployeeMarketplace,
    ),
    marketplace.sagas.fetchEmployerMarketplaceWatcher(
      marketplaceApi.fetchEmployerMarketplace,
    ),
    admin.perks.sagas.fetchAdminPerksWatcher(fetchAdminPerks),
    admin.perks.sagas.fetchAdminArchivedPerksWatcher(fetchAdminArchivedPerks),
    admin.perks.sagas.fetchAdminPerkWatcher(fetchAdminPerk),
    perks.sagas.fetchPerksWatcher(fetchPerks),
    postLoginExperience.sagas.fetchRestartAppTutorialWatcher(
      fetchRestartAppTutorial,
    ),
    postLoginExperience.sagas.completeAppTutorialWatcher(completeAppTutorial),
    blogPosts.sagas.fetchCuratedBlogPostsWatcher(fetchBlogPosts),
    insights.sagas.insightsRequestWatcher(fetchInsights),
  ]);
}
